import { html, css, LitElement } from "lit";
export class A2kPanel extends LitElement {
    render() {
        return html ` <div id="panel">
      <slot></slot>
    </div>`;
    }
}
A2kPanel.styles = css `
    #panel {
      border: var(--panel-border);
      background-color: var(--panel-color-background);
    }
  `;
// https://codepen.io/rootVIII/details/VwMXxKV
// https://www.joshwcomeau.com/react/animating-the-unanimatable/
